import React, { Component } from "react";
// import logoEp from "/assets/image/LOGO_EDUPRIME_2.png";

class HeaderReportPeminatan extends Component {
    render() {
        require("./HeaderReportPeminatan.css");
        const { pageNumber, desc, title, subtitle, logoCbt } = this.props;
        return (
            <div className="head-pnl">
                <div className="pnl-page">
                    <div className="card-page">
                        <span style={{
                            fontSize: '26px',
                            color: '#FFF',
                            fontWeight: 500,
                            fontFamily: 'lucida grande'
                        }}>{pageNumber}</span>
                    </div>
                    <div className="pnl-date">
                        {desc}
                    </div>
                </div>
                <div className="pnl-flex-title">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="head-title">
                            {title}
                        </div>
                        {(subtitle && <>
                            <div className="head-subtit">
                                <span className="text-subTit">{subtitle}</span>
                            </div>
                        </>)}
                    </div>
                    <div className="image-header">
                        <div style={{ width: '40%' }}>
                            <img src='https://eduprime.co.id/static/images/LogoEduprimePutih.png' width={"100%"} />
                        </div>
                        {(logoCbt && <>
                            <div style={{ width: '30%' }}>
                                <img src={logoCbt} width={"100%"} />
                            </div>
                        </>)}
                    </div>
                </div>

            </div>
        );
    }
}

export default HeaderReportPeminatan;